// src/hooks/useStartupFlags.ts
import djSoftwareService from '../services/DJSoftware.service';
import { useEffect, useState } from 'react';
import { useContext } from 'react';
import { LibraryStatsContext } from '../context/LibraryStatsContext';

export function useStartupFlags() {
  const softwareSelected = djSoftwareService.getSelectedSoftware().length > 0;

  // Try to get the context, but don't throw if it's not available
  const context = useContext(LibraryStatsContext);

  // If context is not available, fall back to a simple check
  if (!context) {
    // Fallback: check if there are any tracks in localStorage or use a default
    const hasScannedTracks =
      localStorage.getItem('hasScannedTracks') === 'true';
    return { softwareSelected, hasScannedTracks, isLoading: false };
  }

  const { stats, loading } = context;
  const hasScannedTracks = stats ? stats.totalFiles > 0 : false;

  return { softwareSelected, hasScannedTracks, isLoading: loading };
}
